<p>
  counter-parent works!
</p>

<button (click) = "increase()">Increase</button> &nbsp;&nbsp;
<button (click) = "decrease()">Decrease</button>
<br><br>
<app-counter></app-counter>
